import styled from '@emotion/styled'
import { V2L2LargeModalRoot } from "../V2L2ModalRoot"
import { V2L2ModalTitlebar, V2L1ModalDismissButton } from "../V2ModalTitlebar"
import { useEffect, useRef } from 'react'

const ModalContent = styled.div(({theme}) => ({
	overflowY: 'hidden',
	flex: 1,
	display: 'grid',
	gridTemplateColumns: '20rem 1fr',
	...theme.fonts.mono,
	fontSize: `${12/16}rem`,
	letterSpacing: `${1/32}rem`,
	lineHeight: `${18/12}em`,
}))

const List = styled.div(({theme}) => ({
	backgroundColor: theme.colors.white,
	overflowY: 'scroll',
	whiteSpace: 'nowrap',
	padding: '1rem',
	userSelect: 'none',
	'ul': {
		margin: '0 0 1rem',
		padding: '0.25em 1rem 0',
	},
	'a': {
		textDecoration: 'none',
		color: 'inherit',
		'&:hover': {
			textDecoration: 'underline',
		},
	}
}))

const DetailContent = styled.pre(({theme}) => ({
	display: 'block',
	overflow: 'scroll',
	...theme.fonts.mono,
	backgroundColor: theme.colors.logBg,
	color: theme.colors.white,
	padding: '1rem',
	margin: 0,
	// 'table': {
	// 	borderCollapse: 'collapse',
	// },
	// 'td, th': {
	// 	border: '1px solid white',
	// 	padding: '.25em .5em',
	// },
}))

export interface V2L3DatabaseModalEntity {
	name: string
	objectIds: string[]
}

interface V2L3DatabaseModalProps {
	entities: V2L3DatabaseModalEntity[]
	content?: string
	onEntityClick: (e: React.MouseEvent<HTMLAnchorElement>, entityName: string) => void
	onObjectClick: (e: React.MouseEvent<HTMLAnchorElement>, entityName: string, objectId: string) => void
	onDismissClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const V2L3DatabaseModal = ({entities, content, onEntityClick, onObjectClick, onDismissClick}: V2L3DatabaseModalProps) => {
	const contentRef = useRef<HTMLPreElement|null>(null)
	useEffect(() => {
		if(contentRef.current) {
			contentRef.current.textContent = content ?? ''
			contentRef.current.scrollTop = 0
		}
	}, [content])
	return (
		<V2L2LargeModalRoot>
			<V2L2ModalTitlebar
				title="Local Database"
				buttons={<V2L1ModalDismissButton onClick={onDismissClick} />}
			/>
			<ModalContent>
				<List>
					{entities.map((entity, idx) => (
						<ul key={idx}>
							<li>
								<a href="#" onClick={(e) => onEntityClick(e, entity.name)}>{entity.name}</a>
								{entity.objectIds.length > 0 ? (
									<ul>
										{entity.objectIds.map((id, idx) => (
											<li key={idx}>
												<a href="#" onClick={(e) => onObjectClick(e, entity.name, id)}>
													{id}
												</a>
											</li>
										))}
									</ul>
								) : null}
							</li>
						</ul>
					))}
				</List>
				{/* {loading ? <V2L1LoadingIndicator big shrimp loading={true} /> : null} */}
				<DetailContent ref={contentRef} />
			</ModalContent>
		</V2L2LargeModalRoot>
	)
}
